/**
 * Utility functions for historical events by book data
 */

/**
 * Sort historical events by book alphabetically by book name
 */
export function sortHistoricalEventsByBook(
  items: HistoricalEventsByBook[]
): HistoricalEventsByBook[] {
  return [...items].sort((a, b) => (a.book || '').localeCompare(b.book || ''));
}

/**
 * Get historical events by book data by book name
 */
export function getHistoricalEventsByBookByBook(
  items: HistoricalEventsByBook[],
  book: string
): HistoricalEventsByBook | undefined {
  return items.find(item => item.book === book);
}

/**
 * Filter events by date range
 */
export function filterBookEventsByDateRange(
  events: HistoricalEventByBook[],
  startYear: number,
  endYear: number
): HistoricalEventByBook[] {
  return events.filter(event => {
    const eventStart = event.date.startYear;
    const eventEnd = event.date.endYear || eventStart;
    // Check if event overlaps with the range
    return eventStart <= endYear && eventEnd >= startYear;
  });
}

/**
 * Sort events within a book by start year
 */
export function sortBookEventsByYear(
  events: HistoricalEventByBook[]
): HistoricalEventByBook[] {
  return [...events].sort((a, b) => {
    const yearA = a.date.startYear;
    const yearB = b.date.startYear;
    return yearA - yearB;
  });
}

/**
 * Get events by category
 */
export function filterBookEventsByCategory(
  events: HistoricalEventByBook[],
  category: string
): HistoricalEventByBook[] {
  return events.filter(event => 
    event.categories?.some(cat => cat.category === category)
  );
}

